import React, { Component } from "react";
import { observer } from "mobx-react";
import {
  LuFolder,
  LuFolderOpen,
  LuPauseCircle,
  LuPlayCircle,
  LuPlaySquare,
} from "react-icons/lu";
import { Link, useLocation, useParams } from "react-router-dom";
import projectStore from "../stores/projectStore";
import Logo from "../assets/logo-b.svg";
import loginStore from "../stores/loginStore";
import WaveSurfer from "wavesurfer.js";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    return <Component {...props} location={location} params={params} />;
  };
}

const ViewSharedProject = observer(
  class ViewSharedProject extends Component {
    constructor(props) {
      super(props);
      this.state = {
        openFolders: {},
        folderTree: [],
        project: {},
        currentAudioSampleId: null,
      };

      this.audioRef = React.createRef();
    }

    toggleFolder = (id) => {
      this.setState((prevState) => {
        const newOpenFolders = { ...prevState.openFolders };
        newOpenFolders[id] = !newOpenFolders[id];
        return { openFolders: newOpenFolders };
      });
    };

    handleFileSelect = (fileId) => {
      this.setState((prevState) => {
        const { folderTree } = prevState;

        folderTree.forEach((folder) => {
          folder.children.forEach((child) => {
            if (child.sample_id === fileId) {
              child.IsClientSelected =
                child.IsClientSelected === "True" ? "False" : "True";
            }
          });
        });
        return { folderTree: [...folderTree] };
      });
    };

    saveProjectData = () => {
      const { folderTree, project } = this.state;

      const projectData = {
        ProjectId: project.projectId,
        FolderWithSamplesVoice: folderTree.map((folder) => ({
          FolderId: folder.id,
          FolderName: folder.name,
          VoiceModel: folder.children.map((child) => ({
            SampleId: child.sample_id,
            VoiceName: child.name,
            IsClientSelected: child.IsClientSelected,
          })),
        })),
      };

      console.log("folderTree", folderTree);

      projectStore.createClientFavorite(projectData);

      console.log("Saving project data:", JSON.stringify(projectData, null, 2));
    };

    renderTree = (nodes) => {
      return (
        <ul className="flex flex-1 flex-col list-disc ml-6 mt-4">
          {nodes.map((node) => (
            <li key={node.id} className="flex flex-col items-start mb-2">
              {node.type === "folder" ? (
                <>
                  <div
                    className="cursor-pointer flex items-center"
                    onClick={() => this.toggleFolder(node.id)}
                  >
                    {this.state.openFolders[node.id] ? (
                      <LuFolderOpen className="mr-2" size={20} />
                    ) : (
                      <LuFolder className="mr-2" size={20} />
                    )}
                    <span>{node.name}</span>
                  </div>
                  {this.state.openFolders[node.id] && (
                    <ul className="flex flex-1 flex-col w-[90%] ml-4">
                      {node.children.map((child) => (
                        <li className="flex w-full" key={child.sample_id}>
                          <this.FileItem
                            file={child}
                            onFileSelect={this.handleFileSelect}
                            isSelected={child.IsClientSelected}
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* Save Button */}
                  {/* <div className="mt-4">
                    <button
                      onClick={this.saveProjectData}
                      className="text-xs px-4 py-2 bg-[#130D0D] text-white rounded"
                    >
                      Submit
                    </button>
                  </div> */}
                </>
              ) : (
                <this.FileItem
                  file={node}
                  onFileSelect={this.handleFileSelect}
                  isSelected={node.IsClientSelected}
                />
              )}
            </li>
          ))}
        </ul>
      );
    };

    convertToFolderTree = (data) => {
      return data.map((folder) => {
        return {
          id: folder.folderId,
          name: folder.folderName,
          type: "folder",
          children: folder.voiceSamples.map((sample) => {
            const filePath =
              process.env.REACT_APP_BASE_URL + "/" + sample.samplePath;

            return {
              sample_id: sample.sampleId,
              name: sample.sampleAliasName,
              type: "file",
              filePath: filePath,
              fileType:
                sample.sampleType || sample.sampleAliasName.split(".").pop(),
              IsClientSelected: sample.isClientSelected
                ? sample.isClientSelected
                : "False",
              currentTime: 0, // Add currentTime for each sample
            };
          }),
        };
      });
    };

    playAudio = (file, startTime = 0) => {
      if (this.waveSurfer) {
        this.waveSurfer.destroy(); // Destroy the previous instance
      }

      const container = document.getElementById(`wave-${file.sample_id}`);
      if (!container) {
        console.error("Waveform container not found");
        return;
      }

      this.waveSurfer = WaveSurfer.create({
        container: container,
        waveColor: "gray",
        progressColor: "black",
        height: 23,
        barGap: 1,
        barHeight: 1,
        barWidth: 2,
      });

      this.waveSurfer.load(file.filePath);

      this.waveSurfer.on("ready", () => {
        this.waveSurfer.seekTo(startTime / this.waveSurfer.getDuration());
        this.waveSurfer.play();
        this.setState({ currentAudioSampleId: file.sample_id });
      });

      this.waveSurfer.on("audioprocess", () => {
        const currentTime = this.waveSurfer.getCurrentTime();
        this.setState((prevState) => {
          const updatedFolderTree = prevState.folderTree.map((folder) => {
            return {
              ...folder,
              children: folder.children.map((child) => {
                if (child.sample_id === file.sample_id) {
                  return { ...child, currentTime }; // Update currentTime for the specific sample
                }
                return child;
              }),
            };
          });
          return { folderTree: updatedFolderTree };
        });
      });

      this.waveSurfer.on("finish", () => {
        // Automatically loop the audio
        this.waveSurfer.seekTo(0); // Seek to the beginning
        this.waveSurfer.play(); // Play again
      });
    };

    FileItem = ({ file, onFileSelect, isSelected }) => {
      const ismp4 = file.fileType === "mp4" || file.name.includes("mp4");

      const handlePlayPause = () => {
        if (file.sample_id === this.state.currentAudioSampleId) {
          // Pause the audio if it's already playing
          if (this.waveSurfer) {
            this.waveSurfer.pause(); // Use WaveSurfer's pause method
          }
          this.setState({ currentAudioSampleId: null });
        } else {
          // Play the audio from the current time
          this.playAudio(file, file.currentTime);
        }
      };

      return (
        <div className="flex items-center justify-between w-full gap-x-3">
          {/* <input
            type="checkbox"
            checked={isSelected === "True" ? true : false}
            onChange={() => onFileSelect(file.sample_id)}
            className="ml-2"
          /> */}
          <button
            className="flex flex-[4] flex-row justify-between items-center mt-2 mb-2"
            onClick={handlePlayPause}
          >
            <div className="flex flex-row justify-center items-center">
              {file.sample_id === this.state.currentAudioSampleId ? (
                <LuPauseCircle className="mr-2" size={20} />
              ) : ismp4 ? (
                <LuPlaySquare className="mr-2" size={20} />
              ) : (
                <LuPlayCircle className="mr-2" size={20} />
              )}
              <span>{file.name}</span>
            </div>
          </button>
          <div className="flex-[6] flex items-center gap-4">
            <div id={`wave-${file.sample_id}`} className="w-[300px]"></div>
            {/* Always display current play time */}
            {!ismp4 && (
              <span className="text-xs text-gray-500">
                {Math.floor(file.currentTime / 60)}:
                {("0" + Math.floor(file.currentTime % 60)).slice(-2)}
              </span>
            )}
            {/* Add Wave Component for audio files */}
          </div>
        </div>
      );
    };

    initializeWaveforms = () => {
      const { folderTree } = this.state;

      folderTree.forEach((folder) => {
        folder.children.forEach((sample) => {
          const containerId = `wave-${sample.sample_id}`;
          const container = document.getElementById(containerId);

          if (container && !container.hasChildNodes()) {
            const waveSurfer = WaveSurfer.create({
              container: container,
              waveColor: "gray",
              progressColor: "black",
              height: 23,
              barGap: 1,
              barHeight: 1,
              barWidth: 2,
            });

            waveSurfer.load(sample.filePath);

            sample.waveSurfer = waveSurfer; // Optionally store the WaveSurfer instance
          }
        });
      });
    };

    async componentDidMount() {
      await projectStore
        .getSharedProject(this.props.params.projectId)
        .then((project) => {
          this.setState({ project });

          setTimeout(() => {
            let fol = this.convertToFolderTree(project.foldersSamples);
            this.setState({ folderTree: fol }, () => {
              this.initializeWaveforms(); // Initialize waveforms after folderTree is set
            });
          }, 200);
        });
    }

    render() {
      const { project } = this.state;

      return (
        <div>
          {!loginStore?.userData && (
            <div className="flex flex-1 flex-row bg-white justify-between p-3 lg:p-9 items-center filter drop-shadow-lg">
              <Link className="w-40" to="/dashboard">
                <img className="w-40" src={Logo} alt="Sounds Great" />
              </Link>
            </div>
          )}
          <audio ref={this.audioRef} style={{ display: "none" }} />

          <div className="flex flex-1 flex-col px-8 py-5">
            {project && (
              <>
                <div className="flex flex-row mb-4 gap-3">
                  <span className="font-bold tracking-widest text-2xl ml-3">
                    {project.projectName}
                  </span>
                </div>

                <div>
                  <div className="flex flex-row flex-wrap gap-2">
                    <div className="flex flex-1 flex-col bg-white rounded-md h-screen">
                      <div className="mb-3 p-2 rounded-md border-b mx-2 font-semibold">
                        Project View
                      </div>
                      {this.renderTree(this.state.folderTree)}
                    </div>
                  </div>
                </div>
              </>
            )}
            {!project && (
              <div className="flex flex-1 justify-center items-center">
                <span className="text-2xl font-semibold">No Project Found</span>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
);

export default withRouter(ViewSharedProject);
